<div class="ts-toast-container">
  <div *ngFor="let toast of toasts" class="ts-toast" [ngClass]="getTypeClass(toast.type)">
    <div class="ts-toast-body">
      <span *ngFor="let msg of toast.messages" class="ts-toast-line">{{ msg }}</span>
    </div>
    <button class="ts-toast-dismiss" (click)="dismiss(toast.id)" aria-label="Dismiss">&times;</button>
  </div>
</div>
